<template>
  <div class="h-100">
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeDownShort">
        <div v-if="!loading">
          <div class="d-flex justify-content-start align-items-center mb-3">
            <b-btn
              class="mr-1"
              size="sm"
              variant="secondary"
              @click="exportTechnical"
            >
              <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
              Exportovať
            </b-btn>
            <b-btn
              v-if="$root.user.isAdmin"
              class="text-uppercase"
              size="sm"
              variant="primary"
              @click="add({ type: type })"
            >
              <b-icon class="mr-1" icon="plus" scale="1.5x" />
              Pridať
            </b-btn>
          </div>
          <div v-if="!data.length" class="nodata-container">
            <div class="text-center my-3">
              <div class="mb-3">
                <b-icon font-scale="5" icon="question-diamond" />
              </div>
              <h2 class="mb-3">Žiadne dáta</h2>
            </div>
          </div>
          <template v-else>
            <component
              :is="type + 'View'"
              v-if="type"
              :data="data"
              :energetic="energetic"
            />
          </template>
        </div>
      </transition>
    </b-overlay>
    <add-technical ref="technicalForm" />
  </div>
</template>
<script>
import AddTechnical from './Add'
import PowerView from './power/View'
import GasView from './gas/View'
import WaterView from './water/View'
import HeatView from './heat/View'
import { mapState } from 'vuex'

export default {
  components: {
    AddTechnical,
    PowerView,
    GasView,
    WaterView,
    HeatView,
  },
  data() {
    return {
      loading: false,
      data: [],
      type: null,
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.$root.$on('reloadEnergeticTechnicalData', this.fetchData)
    this.type = this.$store.getters['energetic/getCurrentType']
  },
  beforeDestroy() {
    this.$root.$off('reloadEnergeticTechnicalData')
  },
  methods: {
    add({ type, edit = false }) {
      this.$refs.technicalForm.type = type
      this.$refs.technicalForm.edit = edit
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'add-technical')
      })
    },
    remove(id) {
      this.$swal({
        title: 'Ste si istý?',
        text: 'Naozaj chcete odstrániť tieto technické hodnoty?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api.post(`energetics/${id}/remove_technical`).then((res) => {
            this.$swal({
              type: 'success',
              position: 'top',
              showCloseButton: true,
              text: res.data.message,
              timer: 5000,
            })
            this.fetchData()
          })
        }
      })
    },
    fetchData(silent = false) {
      this.loading = !silent
      this.$api
        .get(
          `energetics/${this.$route.params.energetics_id}/technical/get_list`,
        )
        .then((res) => {
          this.data = res.data.data
          if (!silent) {
            this.loading = false
          }
        })
    },
    exportTechnical() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      this.$api
        .get('energetics/technical/export', {
          params: { id: this.$route.params.energetics_id },
          responseType: 'blob',
        })
        .then((res) => {
          saveAs(
            new Blob([res.data]),
            'technicke-udaje_' +
              this.energetic[
                `${this.$store.getters['energetic/getCurrentType']}Number`
              ] +
              '.xlsx',
          )
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
  },
}
</script>
